// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__wE4Go","title":"Info_title__3a7r2","links":"Info_links__12CRL","link":"Info_link__2NTqA","logo":"Info_logo__2CeHU"};